import { Button, Flex, Form, Input } from 'antd'
import { useEffect, useState } from 'react'
import { Api } from '~/core/trpc'
import { ButtonPrimary } from '~/features/shared/components'
import { ToolboxClient } from '~/plugins/toolbox/client'

type FormValues = { email: string }

type Props = {
  email?: string
  onNext: (step: 'signin' | 'signup', email: string) => void
  onError: (key: string) => void
  hideNotRegistered?: boolean
}

export const StepEmail: React.FC<Props> = ({
  email,
  hideNotRegistered = false,
  onNext,
  onError,
}) => {
  const [form] = Form.useForm<FormValues>()
  const [isRegistering, setRegistering] = useState(false)
  // const [isFormValid, setFormValid] = useState(false)

  const loginEmail = Api.authentication.loginEmail.useMutation()

  const autofocus = ToolboxClient.useAutofocus()

  useEffect(() => {
    if (email) {
      form.setFieldValue('email', email)
      // setFormValid(true)
    }
  }, [email])

  const handleSubmit = async ({ email: _email }: FormValues) => {
    const email = _email?.trim()?.toLowerCase()

    if (loginEmail.isLoading) {
      return
    }

    try {
      const { step, error } = await loginEmail.mutateAsync({ email })

      if (error) {
        onError(error)
      } else {
        onNext(step as any, email)
      }
    } catch (error) {
      console.error('Unknown Error', error)
      onError('offline')
    }
  }

  // const handleChange = async (values: FormValues) => {
  //   const { email } = values
  //   setFormValid(typeof email === 'string' && email.trim() !== '')
  // }

  return (
    <>
      <Form
        form={form}
        onFinish={handleSubmit}
        // onValuesChange={handleChange}
        layout="vertical"
        requiredMark={false}
      >
        <Form.Item
          // label="Email"
          name="email"
          rules={[{ required: true, message: 'Email is required' }]}
        >
          <Input
            type="email"
            placeholder="Your email"
            autoComplete="email"
            variant="filled"
            ref={autofocus.ref}
          />
        </Form.Item>

        <ButtonPrimary
          htmlType="submit"
          block
          size="large"
          // disabled={!isFormValid}
          loading={loginEmail.isLoading}
        >
          {isRegistering ? `Next` : `Continue with email`}
        </ButtonPrimary>
      </Form>
      {!hideNotRegistered && (
        <Flex className="mt-20">
          {isRegistering ? (
            <Button
              block
              type="text"
              loading={loginEmail.isLoading}
              onClick={() => setRegistering(false)}
            >
              Already have an account?{' '}
              <b style={{ fontWeight: 600 }}>Sign in</b>
            </Button>
          ) : (
            <Button
              block
              type="text"
              loading={loginEmail.isLoading}
              onClick={() => setRegistering(true)}
            >
              Not registered yet?{' '}
              <b style={{ fontWeight: 600 }}>Create an account</b>
            </Button>
          )}
        </Flex>
      )}
    </>
  )
}
